var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e/icon/arrows/arrow_left_line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.63603 11.293C3.24551 11.6835 3.24551 12.3167 3.63603 12.7072L9.29289 18.3641C9.68341 18.7546 10.3166 18.7546 10.7071 18.3641C11.0976 17.9736 11.0976 17.3404 10.7071 16.9499L6.75735 13.0001H20C20.5523 13.0001 21 12.5524 21 12.0001C21 11.4478 20.5523 11.0001 20 11.0001H6.75735L10.7071 7.05037C11.0976 6.65984 11.0976 6.02668 10.7071 5.63616C10.3166 5.24563 9.68341 5.24563 9.29289 5.63616L3.63603 11.293Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftLine);
export default __webpack_public_path__ + "static/media/arrow_left_line.e2ef0952b692e263d75ae07ae09d76e7.svg";
export { ForwardRef as ReactComponent };